/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import React, { Component } from 'react';
import { Spinner } from 'react-bootstrap';
import HomeService from "../../services/home.service";
import AssetService from '../../services/asset.service';
import SelectHome from "./SelectHome";
import AddHouseModal from "./AddHouseModal";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import Map from './../Map/Map';

import memoize from "memoize-one";

import { jsHouse } from "../../componentObjects";
import { PageView, Event, ModalView } from "../GoogleAnalytics";
import {withRouter} from "../Routing/withRouter";
import Loader from "../Loader/Loader";

class Home extends Component {
    static displayName = Home.name;
    _isMounted = false;

    constructor(props) {
        super(props);

        this.populateHomeData = this.populateHomeData.bind(this);
        this.populateProLocationData = this.populateProLocationData.bind(this);
        //this.populateHomeDataNew = this.populateHomeDataNew.bind(this); 
        
        this.addHome = this.addHome.bind(this);
        this.updateHome = this.updateHome.bind(this);
        this.deleteHome = this.deleteHome.bind(this);

        this.updateHomeListInParent = this.updateHomeListInParent.bind(this);
        this.removeFromHomeList = this.removeFromHomeList.bind(this);
        this.addToHomeList = this.addToHomeList.bind(this);

        this.showAddHomeModal = this.showAddHomeModal.bind(this);
        this.openAddHomeModal = this.openAddHomeModal.bind(this);

        this.onHomeSelect = this.onHomeSelect.bind(this);
        this.onChangeNickName = this.onChangeNickName.bind(this);
        this.onChangeAddress = this.onChangeAddress.bind(this);
        this.onChangeCity = this.onChangeCity.bind(this);
        this.onChangeState = this.onChangeState.bind(this);
        this.onChangeZip = this.onChangeZip.bind(this);
        this.onChangeLatitude = this.onChangeLatitude.bind(this);
        this.onChangeLongitude = this.onChangeLongitude.bind(this);
        this.onChangeLocation = this.onChangeLocation.bind(this);

        this.onNickNameChange = this.onNickNameChange.bind(this);
        this.onAddressChange = this.onAddressChange.bind(this);
        this.onCityChange = this.onCityChange.bind(this);
        this.onStateChange = this.onStateChange.bind(this);
        this.onZipChange = this.onZipChange.bind(this);        
        this.onLatitudeChange = this.onLatitudeChange.bind(this);
        this.onLongitudeChange = this.onLongitudeChange.bind(this);
        this.onLocationChange = this.onLocationChange.bind(this);
        this.onLocationRecordIdChange = this.onLocationRecordIdChange.bind(this);
        this.onLocationRecordIdAddHomeChange = this.onLocationRecordIdAddHomeChange.bind(this);

        this.openUpdateHomeModal = this.openUpdateHomeModal.bind(this);
        this.showUpdateHomeModal = this.showUpdateHomeModal.bind(this);
        this.openDeleteHomeModal = this.openDeleteHomeModal.bind(this);
        this.showDeleteHomeModal = this.showDeleteHomeModal.bind(this);

        this.onContinueWithoutSaving = this.onContinueWithoutSaving.bind(this);
        this.onSaveThenContinue = this.onSaveThenContinue.bind(this);
        
        this.state = {
            homeList: [],
            loading: false,
            homeLoading: false,
            currentHome: jsHouse,
            newHome: jsHouse,
            showAddHome: false,
            statusMessage: null,
            showStatusMessage: null,
            showDeleteConfirmation: false,
            showUpdateConfirmation: false,
            modalMessage: "",
            modalTitle: "",
            isCustomerSupport: localStorage.getItem('isCustomerSupport') === 'true' || false,
            showUnsavedModal: null,
            unsavedChanges: false,
            homeAssetId : ""
        };             
    }

    getStorageValue(key, defaultValue) {
        const saved = localStorage.getItem(key);
        const value = saved !== null ? saved : defaultValue;
        return value;
    }

    componentDidMount() {
        this._isMounted = true;
        PageView();

        let unsavedChanges = this.getStorageValue("unsavedChanges", false);
            if (unsavedChanges === 'true' || unsavedChanges === true) {
                let homeList = localStorage.getItem("homeList", '[]');
                if (homeList !== '[]')
                    homeList = JSON.parse(homeList);
                let currentHome = localStorage.getItem("currentHome", jsHouse);
                if (currentHome !== jsHouse)
                    currentHome = JSON.parse(currentHome);
                if (homeList !== '[]' && homeList.length) {
                    var homeIndex = homeList.findIndex(h => h.assetId === currentHome.assetId);
                    homeList[homeIndex] = currentHome;
                }
                this.setState({ homeList: homeList, currentHome: currentHome });
            }
            else 
                this.populateHomeData();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.currentCustomerId !== this.props.currentCustomerId || 
            prevProps.proCustomerId !== this.props.proCustomerId) {
            this.populateHomeData();
        }
    }
    componentWillUnmount() {
        this._isMounted = false;
    }

    //memHomeData = memoize(this.populateHomeDataNew);
    
    onHomeSelect(e) {
        this.setState({
            currentHome: e
        }, () => {
            localStorage.setItem("currentHome", JSON.stringify(this.state.currentHome));
        });
    }        

    showAddHomeModal = e => {
        this.setState({
            showAddHome: !this.state.showAddHome
        }, () => {
                if (this.state.showAddHome)
                    ModalView("addHomeModal");
        });
        window.scrollTo(0, 0);
    }

    openAddHomeModal() {
        this.setState(prevState => ({
            newHome: {
                ...prevState.newHome,
                orgId: this.props.currentCustomerId
            }
        }));

        this.showAddHomeModal(null);
    }

    updateHomeListInParent(currentHome) {
        for (let i = 0; i < this.state.homeList.length; i++) {

            if (this.state.homeList[i].assetId === currentHome.assetId) {
                // our location is i

                let homes = [...this.state.homeList];

                let home = { ...homes[i] };

                home = currentHome;

                homes[i] = home;

                localStorage.setItem("homeList", JSON.stringify(this.state.homeList));
                if (this._isMounted)
                    this.setState({ homeList: homes, currentHome: currentHome });
            }
        }
    }

    removeFromHomeList(currentHome) {

        for (let i = 0; i < this.state.homeList.length; i++) {

            if (this.state.homeList[i].assetId === currentHome.assetId) {
                var array = [...this.state.homeList];

                if (i !== -1) {
                    array.splice(i, 1);
                    this.setState({ homeList: array }, () => {
                        localStorage.setIem("homeList", JSON.stringify(this.state.homeList));
                    });
                }

            }
        }
    }

    addToHomeList(newHome) {
        var homes = [...this.state.homeList];

        homes.push(newHome);

        this.setState({ homeList: homes }, () => {
            localStorage.setItem("homeList", JSON.stringify(homes));
        });
    }

    addHome() {
        this.setState({ loading: true });
        this.setState(prevState => ({
            newHome: {
                ...prevState.newHome,
                orgId: this.props.currentCustomerId,
                parentId: this.props.currentPartnerId
            }
        }), () => {
            HomeService.add(this.state.newHome)
                .then(response => {
                    let message = "";

                    if (response.data !== undefined && response.data.houseAssetId !== "") {
                        message = "Successfully added new home!";
                        Event("Add Home Clicked", "User clicked add home button", "Add Customer Home Clicked");

                        this.addToHomeList(this.state.newHome);

                        let index = this.state.homeList.indexOf(this.state.newHome);

                        this.setState({
                            showAddHome: !this.state.showAddHome, statusMessage: message, loading: false,
                            newHome: jsHouse, currentHome: response.data
                        }, () => {
                            localStorage.setItem("unsavedChanges", false);
                            localStorage.setItem("currentHome", JSON.stringify(this.state.currentHome));
                        });

                    }
                    else {
                        message = "Failed to add new home!";

                        this.setState({
                            showAddHome: !this.state.showAddHome, statusMessage: message,
                            newHome: jsHouse, currentHome: response.data, loading: false
                        }, () => {
                            localStorage.setItem("unsavedChanges", false);
                            localStorage.setItem("currentHome", JSON.stringify(this.state.currentHome));
                        });
                    }
                }).then(this.populateHomeData)
                .catch(e => {
                    console.log(e);
                    this.setState({ loading: false });
                });
        });
    }    

    onSaveThenContinue() {
        this.setState({ loading: true, showUnsavedModal: false }, () => {
            localStorage.setItem("showUnsavedModal", false);
            var currentHome = this.getStorageValue("currentHome", jsHouse);
            if (currentHome !== jsHouse)
                currentHome = JSON.parse(currentHome);
            var homeList = this.getStorageValue("homeList", '[]');
            if (homeList !== '[]')
                homeList = JSON.parse(homeList);
            this.setState({ currentHome: currentHome, homeList: homeList }, () => {
                this.updateHome(true);
            });
            
        })
    }

    onContinueWithoutSaving() {
        localStorage.setItem("unsavedChanges", false);
        localStorage.setItem("showUnsavedModal", false);
        localStorage.setItem("currentHome", JSON.stringify(jsHouse));
        localStorage.setItem("homeList", '[]');
        let activePath = this.getStorageValue("activePath", "/home");
        let nextPath = this.getStorageValue("nextPath", null);

        this.props.navigate(nextPath);
        this.props.setActivePath(nextPath);
    }

    updateHome(goNextPage = false) {
        this.setState({ loading: true });
        this.setState(prevState => ({
            currentHome: goNextPage ? this.state.currentHome : {
                ...prevState.currentHome,
                orgId: this.props.currentCustomerId,
                parentId: this.props.currentPartnerId
            }
        }), () => {
            HomeService.update(
                this.state.currentHome
            ).then(response => {
                let message = "";

                if (response.status === 200 && response.data !== undefined && response.data !== null && response.data !== false) {
                    message = "Successfully updated home!";
                    Event("Update Home Clicked", "User clicked update home button", "Update Customer Home Clicked");

                    if (this._isMounted)
                        this.setState({
                            statusMessage: message,
                            showUpdateConfirmation: false,
                            loading: false
                        }, async () => {
                            if (response.status === 200) {
                                console.log("Successfully updated home assets cache");
                                localStorage.setItem("unsavedChanges", false);
                                localStorage.setItem("showUnsavedModal", false);
                                if (goNextPage === true || goNextPage === 'true')
                                    this.onContinueWithoutSaving();
                            }
                            else {
                                console.log("Failed to refresh home assets cache")
                            }
                        });

                    // update the master list in app.js.
                    if (goNextPage !== true && goNextPage !== 'true')
                        this.updateHomeListInParent(this.state.currentHome);
                }
                else {
                    message = "Failed to update home!";

                    if (this._isMounted)
                        this.setState({ statusMessage: message, showUpdateConfirmation: false, loading: false });
                }

            }).catch(e => {
                console.log(e);
                this.setState({ loading: false });
            });
        });
    }

    deleteHome() {
        this.setState({ loading: true });
        HomeService.delete(this.state.currentHome.assetId, this.props.currentCustomerId, this.props.currentPartnerId)
            .then(response => {
                let message = "";

                if (response.status === 200 && response.data !== undefined && response.data !== null && response.data !== false) {
                    message = "Successfully deleted home!";
                    Event("Delete Home Clicked", "User clicked delete home button", "Delete Customer Home Clicked");

                    if (this._isMounted)
                        this.setState({ statusMessage: message, showDeleteConfirmation: false, loading: true });

                    this.removeFromHomeList(this.state.currentHome);
                }
                else {
                    message = "Failed to delete home!";

                    if (this._isMounted)
                        this.setState({ statusMessage: message, showDeleteConfirmation: false, loading: true });
                }

            }).then(this.populateHomeData)
            .catch(e => {
                console.log(e);
                this.setState({ loading: true });
            });
    }

    showDeleteHomeModal() {
        this.setState({
            showDeleteConfirmation: !this.state.showDeleteConfirmation
        }, () => {
                if (this.state.showDeleteConfirmation)
                    ModalView("deleteHomeConfirm");
        });
        window.scrollTo(0, 0);
    }

    openDeleteHomeModal() {
        this.setState({ modalMessage: "Are you sure you wish to delete this Home?", modalTitle: "Delete Home" }, () => {
            this.showDeleteHomeModal();
        });
    }

    showUpdateHomeModal() {
        this.setState({
            showUpdateConfirmation: !this.state.showUpdateConfirmation
        }, () => {
                if (this.state.showUpdateConfirmation)
                    ModalView("updateHomeConfirm");
        });
        window.scrollTo(0, 0);
    }

    openUpdateHomeModal() {
        this.setState({ modalMessage: "Are you sure you wish to update this Home?", modalTitle: "Update Home" }, () => {
            this.showUpdateHomeModal();
        });
    }

    /**
     * begin input event handlers
     */
    onChangeNickName(e) {
        const nickName = e.target.value;

        this.setState(prevState => ({
            unsavedChanges: true,
            currentHome: {
                ...prevState.currentHome,
                nickname: nickName
            }
        }), () => {
            localStorage.setItem("unsavedChanges", true);
            localStorage.setItem("currentHome", JSON.stringify(this.state.currentHome));
        });
    }

    onChangeAddress(e) {
        const address = e.target.value;

        this.setState(prevState => ({
            unsavedChanges: true,
            currentHome: {
                ...prevState.currentHome,
                address: address
            }
        }), () => {
            localStorage.setItem("unsavedChanges", true);
            localStorage.setItem("currentHome", JSON.stringify(this.state.currentHome));
        });
    }

    onChangeCity(e) {
        const city = e.target.value;

        this.setState(prevState => ({
            unsavedChanges: true,
            currentHome: {
                ...prevState.currentHome,
                city: city
            }
        }), () => {
            localStorage.setItem("unsavedChanges", true);
            localStorage.setItem("currentHome", JSON.stringify(this.state.currentHome));
        });
    }

    onChangeState(e) {
        const state = e.target.value;

        this.setState(prevState => ({
            unsavedChanges: true,
            currentHome: {
                ...prevState.currentHome,
                state: state
            }
        }), () => {
            localStorage.setItem("unsavedChanges", true);
            localStorage.setItem("currentHome", JSON.stringify(this.state.currentHome));
        });
    }

    onChangeZip(e) {
        const zip = e.target.value;

        this.setState(prevState => ({
            unsavedChanges: true,
            currentHome: {
                ...prevState.currentHome,
                zip: zip
            }
        }), () => {
            localStorage.setItem("unsavedChanges", true);
            localStorage.setItem("currentHome", JSON.stringify(this.state.currentHome));
        });
    }

    /* LOCATION EVENTS */ 
    onChangeLatitude(e) {
        const latitude = e.target.value;

        this.setState(prevState => ({
            unsavedChanges: true,
            currentHome: {
                ...prevState.currentHome,
                latitude: latitude
            }
        }), () => {
            localStorage.setItem("unsavedChanges", true);
            localStorage.setItem("currentHome", JSON.stringify(this.state.currentHome));
        });
        this.onChangeLocation();
    }

    onChangeLongitude(e) {
        const longitude = e.target.value;

        this.setState(prevState => ({
            unsavedChanges: true,
            currentHome: {
                ...prevState.currentHome,
                longitude: longitude
            }
        }), () => {
            localStorage.setItem("unsavedChanges", true);
            localStorage.setItem("currentHome", JSON.stringify(this.state.currentHome));
        });
        this.onChangeLocation();
    }

    onChangeLocation() {
        const location = this.state.currentHome.latitude + "," + this.state.currentHome.longitude;

        this.setState(prevState => ({
            unsavedChanges: true,
            currentHome: {
                ...prevState.currentHome,
                location: location 
            }
        }), () => {
            localStorage.setItem("unsavedChanges", true);
            localStorage.setItem("currentHome", JSON.stringify(this.state.currentHome));
        });
    }

    onLocationRecordIdChange(e) {
        const regex = /^\d+$/;
        let locationRecordId = e.target.value;
        
        if ((regex.test(locationRecordId) || locationRecordId === "") && locationRecordId.length <= 7) {
            this.setState(prevState => ({
                unsavedChanges: true,
                currentHome: {
                    ...prevState.currentHome,
                    locationId: locationRecordId
                }
            }), () => {
                localStorage.setItem("unsavedChanges", true);
                localStorage.setItem("currentHome", JSON.stringify(this.state.currentHome));
            });
        }
    }
    /*end*/


    onNickNameChange(e) {
        var nickName = e.target.value;
        nickName = nickName.replace("'", "&#39;");

        this.setState(prevState => ({
            newHome: {
                ...prevState.newHome,
                nickname: nickName
            }
        }));
    }

    onAddressChange(e) {
        const address = e.target.value;

        this.setState(prevState => ({
            newHome: {
                ...prevState.newHome,
                address: address
            }
        }));
    }
    onCityChange(e) {
        const city = e.target.value;

        this.setState(prevState => ({
            newHome: {
                ...prevState.newHome,
                city: city
            }
        }));
    }
    onStateChange(e) {
        const state = e.target.value;

        this.setState(prevState => ({
            newHome: {
                ...prevState.newHome,
                state: state
            }
        }));
    }
    onZipChange(e) {
        const zip = e.target.value;

        this.setState(prevState => ({
            newHome: {
                ...prevState.newHome,
                zip: zip
            }
        }));
    }

    /* LOCATION EVENTS 2 */
    onLatitudeChange(e) {
        const latitude = e.target.value;

        this.setState(prevState => ({
            newHome: {
                ...prevState.newHome,
                latitude: latitude 
            }
        }));
        this.onLocationChange();
    }

    onLongitudeChange(e) {
        const longitude = e.target.value;

        this.setState(prevState => ({
            newHome: {
                ...prevState.newHome,
                longitude: longitude 
            }
        }));
        this.onLocationChange();
    }

    onLocationChange() {
        const location = this.state.newHome.latitude + "," + this.state.newHome.longitude;

        this.setState(prevState => ({
            newHome: {
                ...prevState.newHome,
                location: location 
            }
        }));
    }

    onLocationRecordIdAddHomeChange(e) {
        const regex = /^[0-9\b]+$/;
        let locationRecordId = e.target.value.replace(/\+|-/gi, "");

        if ((regex.test(locationRecordId) || locationRecordId === "") && locationRecordId.length <= 7) {
            this.setState(prevState => ({
                newHome: {
                    ...prevState.newHome,
                    locationId: locationRecordId
                }
            }));
        }
    }

    getPrettyName(name) {
        if (name !== null && name !== undefined) {

            var split = name.split("__");
            var name = split[0].replace("?", "'");

            const indexOfSlash = name.indexOf(' / ');
            if (indexOfSlash !== -1) {
                name = name.substring(indexOfSlash + 3);
            }
            return name;
        }
        else {
            return "";
        }
    }

    /**
     * end input event handlers
     */

    renderHomes(homeList, currentId) {
        let LocationId = (this.props.hasServiceTitan && this.props.hasBilling ) ?
            <div>
                <label>Service Titan Location Id</label>
                <div className="row">
                    <div className="col">
                        <input
                            type="text"
                            className="form-control"
                            id="add-latitude"
                            value={this.state.currentHome?.locationId}
                            onChange={this.onLocationRecordIdChange}
                            placeholder="Service Titan Location Id"
                        />
                    </div>
                </div>
            </div>
            : null 
        if (homeList !== null && homeList.length){
            return (
                <div>
                    <div style={{ display: 'none' }}>{currentId}</div>

                    <div className="row no-gutters">      
                        <div className="white-container col-sm-12 col-md-9 col-lg-6">
                            <SelectHome homes={homeList} onChange={this.onHomeSelect} />
                        </div>
                        <div className="white-container col-sm-12 col-md-9 col-lg-6">

                            <form className="input-container">  
                                
                            <div>
                                <label>Nickname</label>
                                <input 
                                    type="text"
                                    className="form-control"
                                        id="nick-name"
                                        value={this.getPrettyName(this.state.currentHome.nickname)}
                                    onChange={this.onChangeNickName}
                                />
                            </div>
                            <div>
                                <label>Address</label>
                                <input 
                                    type="text"
                                    className="form-control"
                                    id="address"
                                    value={this.state.currentHome.address}
                                    onChange={this.onChangeAddress}
                                />
                            </div>
                            <div>
                                <label>City</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="city"
                                    value={this.state.currentHome.city}
                                    onChange={this.onChangeCity}
                                />
                            </div>
                            <div>
                                <label>State</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="state"
                                    value={this.state.currentHome.state}
                                    onChange={this.onChangeState}
                                />
                            </div>
                            <div>
                                <label>Zip</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="zip"
                                    value={this.state.currentHome.zip}
                                    onChange={this.onChangeZip}
                                />
                            </div>                       
                            <div style={{ marginBottom: '15px' }}>
                                <label>Location</label>
                                <div className="row">
                                    <div className="col">
                                        <input 
                                            type="text"
                                            className="form-control"
                                            id="latitude"
                                            value={this.state.currentHome.latitude}
                                            onChange={this.onChangeLatitude}
                                            placeholder="Latitude"
                                        />
                                    </div>
                                    <div className="col">
                                        <input 
                                            type="text"
                                            className="form-control"
                                            id="longitude"
                                            value={this.state.currentHome.longitude}
                                            onChange={this.onChangeLongitude}
                                            placeholder="Longitude"
                                        />
                                    </div>
                                </div>
                            </div>
                                {LocationId}
                                {this.state.currentHome?.proLocationId && (
                                    <div>
                                        <label>Pro Location ID</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="pro-location-id"
                                            value={this.state.currentHome.proLocationId}
                                            readOnly
                                            disabled
                                        />
                                    </div>
                                )}
                            </form>
                        </div>

                    </div>
                    <p className="status-msg">{this.state.statusMessage}</p>
                    {(!this.state.isCustomerSupport) && (
                        <div className="table-container">
                            <button
                                type="button"
                                className="secondary-btn btn-small"
                                onClick={this.openAddHomeModal}
                            >
                                Add Home
                            </button>

                            <button
                                type="button"
                                className="secondary-btn btn-small"
                                onClick={this.openUpdateHomeModal}
                            >
                                Update Home
                            </button>

                            {/* TODO uncomment when ready to enable delete buttons - NW
                            <button
                                type="button"
                                className="secondary-btn btn-small"
                                onClick={this.openDeleteHomeModal}
                            >
                                Delete Home
                            </button>
                            */}


                        </div>)}

                    <AddHouseModal newHome={this.state.newHome} onClick={this.showAddHomeModal} show={this.state.showAddHome} onSave={this.addHome} onNickNameChange={this.onNickNameChange}
                        onAddressChange={this.onAddressChange} onCityChange={this.onCityChange} onStateChange={this.onStateChange} onZipChange={this.onZipChange} onLatitudeChange={this.onLatitudeChange} onLongitudeChange={this.onLongitudeChange} onLocationChange={this.onLocationChange}
                        onLocationRecordIdAddHomeChange={this.onLocationRecordIdAddHomeChange} hasBilling={this.props.hasBilling} hasServiceTitan={this.props.hasServiceTitan} >

                    </AddHouseModal>

                    <ConfirmationModal show={this.state.showDeleteConfirmation} onYes={this.deleteHome} onClick={this.showDeleteHomeModal} message={this.state.modalMessage} title={this.state.modalTitle}> </ConfirmationModal>

                    <ConfirmationModal show={this.state.showUpdateConfirmation} onYes={() =>this.updateHome()} onClick={this.showUpdateHomeModal} message={this.state.modalMessage} title={this.state.modalTitle}> </ConfirmationModal>
                    
                </div>
            );
        }
        else if (this.props.currentCustomerId === -1) {
            return (
                <div>
                    <p className="status-msg">No customer home information to display.</p>
                </div>
            );
        }
        else{
            return (
                <div style={{ marginLeft: '10px' }}>
                    <div><br />No Homes located!</div>
                    <br/>
                    <button
                        type="button"
                        className="primary-btn btn-small"
                        onClick={this.openAddHomeModal}
                    >
                        Add Home
                        </button>

                    <AddHouseModal newHome={this.state.newHome} onClick={this.showAddHomeModal} show={this.state.showAddHome} onSave={this.addHome} onNickNameChange={this.onNickNameChange}
                        onAddressChange={this.onAddressChange} onCityChange={this.onCityChange} onStateChange={this.onStateChange} onZipChange={this.onZipChange} onLatitudeChange={this.onLatitudeChange} onLongitudeChange={this.onLongitudeChange} onLocationChange={this.onLocationChange} >

                    </AddHouseModal>
                </div>
            );
        }
    }

    render() {
        const { classes } = this.props;

        let contents = this.state.loading
            ? <Loader />
            : this.renderHomes(this.state.homeList, this.props.currentCustomerId);

        return (
            <div sx={(theme)=>({
                [theme.breakpoints.down('md')]: {
                    marginLeft: '-225px !important',
                },
            })}>
                <div className='infoPage'>
                    <h3 className="pageTitle" id="tabelLabel" >Home</h3>                
                    {contents}
                    <Map  currentPartnerId={this.props.currentPartnerId} isPartnerAdmin={this.props.isPartnerAdmin} currentCustomerId={this.props.currentCustomerId} setCurrentCustomerId={this.props.setCurrentCustomerId} partnerList={this.props.partnerList} setActivePath={this.props.setActivePath} isLoading={this.props.loading} currentHomeAssetId = {this.state.homeAssetId} />
                    <ConfirmationModal 
                        show={this.state.showUnsavedModal == null ? this.getStorageValue("showUnsavedModal", false) === 'true' : this.state.showUnsavedModal} 
                        onYes={this.onSaveThenContinue} 
                        onClick={this.onContinueWithoutSaving} 
                        message={"You have unsaved changes, would like to save before leaving?"} 
                        title={"Unsaved Changes"}></ConfirmationModal>
                </div>
            </div>
        );
    }

    populateHomeData() {
            // If pro IDs are available, use the RIS-backed location endpoint
            if (this.props.proCompanyId && this.props.proCustomerId) {
                this.populateProLocationData();
                return;
            }

            this.setState({ loading: true }, async () => {
                await HomeService.get(this.props.currentCustomerId, this.props.currentPartnerId).then(homeResponse => {
                    if (this._isMounted)
                        this.setState({ homeList: homeResponse.data, currentHome: homeResponse.data[0], homeAssetId :homeResponse.data[0]?.assetId }, () => {
                            this.setState({ loading: false }, () => {
                                localStorage.setItem("unsavedChanges", false);
                                localStorage.setItem("homeList", JSON.stringify(this.state.homeList));
                                localStorage.setItem("currentHome", JSON.stringify(this.state.currentHome));
                            });
                        });
                }).catch(e => {
                    console.log(e);
                });
            })
    }

    populateProLocationData() {
        this.setState({ loading: true }, async () => {
            try {
                const response = await HomeService.getProLocations(this.props.proCompanyId, this.props.proCustomerId);
                if (this._isMounted && response.data) {
                    // Map pro locations to jsHouse-compatible shape
                    const locations = response.data.map(loc => ({
                        orgId: this.props.currentCustomerId || "",
                        parentId: this.props.currentPartnerId || "",
                        assetId: loc.assetId || 0,
                        nickname: loc.nickname || loc.name || "",
                        address: loc.address || loc.addressLine1 || "",
                        city: loc.city || "",
                        state: loc.state || loc.stateProvinceRegionCode || "",
                        zip: loc.zip || loc.zipPostalCode || "",
                        latitude: loc.latitude || "",
                        longitude: loc.longitude || "",
                        location: loc.location || "",
                        locationId: loc.locationId || "",
                        proLocationId: loc.proLocationId || loc.id || ""
                    }));

                    this.setState({
                        homeList: locations,
                        currentHome: locations[0] || jsHouse,
                        homeAssetId: locations[0]?.assetId || ""
                    }, () => {
                        this.setState({ loading: false }, () => {
                            localStorage.setItem("unsavedChanges", false);
                            localStorage.setItem("homeList", JSON.stringify(this.state.homeList));
                            localStorage.setItem("currentHome", JSON.stringify(this.state.currentHome));
                        });
                    });
                }
            } catch (e) {
                console.log("Error loading pro locations:", e);
                this.setState({ loading: false });
            }
        });
    }

    /*async populateHomeDataNew(propId) {
        await HomeService.get(propId).then(homeResponse => {
            if (this._isMounted)
                this.setState({ homeList: homeResponse.data, currentHome: homeResponse.data[0], selectedHomeIndex: 0 }, () => {
                    this.setState({ loading: false });
                });
        }).catch(e => {
            console.log(e);
        });
    }*/
}

export default withRouter(Home);
